(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["policy-agreement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('policy-agreement')) {
    customElements.define('policy-agreement', class extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.timestamp = this.querySelector('[data-policy-agreed-at]');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.checkbox || !this.timestamp || !this.form) return;

        this.onChange = () => {
          this.timestamp.value = this.checkbox.checked ? new Date().toISOString() : '';
        };
        this.onSubmit = (event) => {
          if (!this.checkbox.checked) {
            event.preventDefault();
            this.checkbox.reportValidity();
            return;
          }
          this.timestamp.value = new Date().toISOString();
        };
        this.checkbox.addEventListener('change', this.onChange);
        this.form.addEventListener('submit', this.onSubmit);
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('submit', this.onSubmit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
